import { extend } from '../../util/jquery.js';
import { getValue } from '../../util/object';
export default class AutoComplete {
    constructor(option) {
        this.securityManager = option.securityManager;
        this.apiManager = option.apiManager;
    }
    async query(params) {
        const data = await this.apiManager.autocomplete(params);
        data.result.map(d => {
            if (d.rtExchangeId) {
                extend(
                    d,
                    this.securityManager.getExtraExchangeInfo(d.rtExchangeId)
                );
            } else {
                d.shortExchangeName = d.exchangeName = getValue(
                    d,
                    'rdbExchange,region'
                );
            }
            return d;
        });
        return data;
    }
}
